import DeckFactory from 'app/stores/decks/DeckFactory';

export default function cloudDeckFactory({ store }) {
  const { $devices } = store;
  const deck = new DeckFactory('i_cloud');
  const { widgets, layout, createWidget, newRow } = deck;

  const hasAws = $devices.hasAWSDevice;
  const hasGcp = $devices.hasGCEDevice;
  const hasOci = $devices.hasOCIDevice;
  const hasAzure = $devices.hasAzureDevice;

  const inventoryCount = [hasAws, hasAzure, hasOci].filter(Boolean).length;
  let inventoryWidth = 12 / inventoryCount;
  let overviewWidth = 8;
  let insightsWidth = 4;
  if (inventoryCount === 1) {
    // merge first 2 rows into one if only one cloud provider
    inventoryWidth = 4;
    overviewWidth = 5;
    insightsWidth = 3;
  }

  // first row
  if (hasAws) {
    createWidget({
      name: 'awsInventory',
      h: 7,
      w: inventoryWidth,
      smallH: 4
    });
  }
  if (hasAzure) {
    createWidget({
      name: 'azureInventory',
      h: 7,
      w: inventoryWidth,
      smallH: 4
    });
  }
  if (hasOci) {
    createWidget({
      name: 'ociInventory',
      h: 7,
      w: inventoryWidth,
      smallH: 4
    });
  }
  if (inventoryCount > 1) {
    newRow(7);
  }

  // second row
  createWidget({
    name: 'cloudTrafficOverview',
    h: 7,
    w: overviewWidth,
    smallH: 4
  });
  createWidget({
    name: 'insightsOverview',
    config: {
      creationTimeDuration: '168h',
      families: ['Hybrid Cloud']
    },
    h: 7,
    w: insightsWidth,
    smallH: 4
  });
  newRow(7);

  // next row
  if (hasAws) {
    createWidget({
      name: 'vpcByTransitGateway',
      h: 6,
      w: 4,
      smallH: 4
    });
    createWidget({
      name: 'gatewayTraffic',
      h: 6,
      w: 4,
      smallH: 4
    });
    createWidget({
      name: 'awsRejectActions',
      config: { dst: 'vpc', src: 'vpc', metric: 'avg_pkts_per_sec', trf_profile: 'cloud internal' },
      h: 6,
      w: 4,
      smallH: 4
    });
    newRow(6);
  }

  // next row
  if (hasAzure) {
    createWidget({
      name: 'gatewayTraffic',
      config: { cloudType: 'azure', title: 'Azure Gateway Traffic' },
      h: 6,
      w: 4,
      smallH: 4
    });
  }

  if (hasAws) {
    createWidget({
      name: 'cloudTrafficProfile',
      config: { cloud_type: 'aws', cloud_region: 'All Regions' },
      h: 4,
      w: 3,
      smallH: 3
    });
  }

  if (hasAzure) {
    createWidget({
      name: 'cloudTrafficProfile',
      config: { cloud_type: 'azure', cloud_region: 'All Regions' },
      h: 4,
      w: 3,
      smallH: 3
    });
  }

  if (deck.layoutX > 9) {
    newRow(hasAzure ? 6 : 4);
  }

  if (hasGcp) {
    createWidget({
      name: 'cloudTrafficProfile',
      config: { cloud_type: 'gcp', cloud_region: 'All Regions' },
      h: 4,
      w: 3,
      smallH: 3
    });
  }

  if (deck.layoutX > 9) {
    newRow(hasAzure ? 6 : 4);
  }

  if (hasAws || hasAzure || hasGcp) {
    createWidget({
      name: 'cloudFlow',
      h: 4,
      w: deck.layoutX === 0 ? 6 : 3,
      smallH: 3
    });
  }

  return {
    widgets,
    layout
  };
}
